export const BRAND = {
  name: "M-Line Solutions",
  tagline: "INNOVATE · CONNECT · GROW",
  phone: "015510083874",
  email: "mleinesolutions@gmail.com",
  emailInfo: "info@m-linesolutions.de",
  address: "Babbergerstr. 3, 76189 Karlsruhe",
  logoUrl:
    "https://customer-assets-0z36b82j.emergentagent.net/job_a3c50bb0-3076-4af2-a6d2-01910c6ee7ee/artifacts/d6bae954220d1db0_WhatsApp%20Image%202026-09-23%20at%2018.53.51.jpeg",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
